<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="180px">
      <span>注：全部材料需加盖公章并彩色扫描。</span>
      <el-table
        :data="tableData"
        stripe
        :header-cell-style="{ textAlign: 'center' }"
      >
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column
          align="left"
          prop="Designation"
          width="150"
          label="材料名称"
        >
          <template #default="scoped">
            <span v-if="scoped.$index < 3">* </span>{{ scoped.row.Designation }}
          </template>
        </el-table-column>
        <el-table-column align="left" prop="material_reques" label="材料要求">
        </el-table-column>
        <el-table-column
          prop="fileName"
          label="已上传材料"
          width="240"
          align="left"
        >
          <template #default="{ row, $index }">
            <el-link class="db" @click="handleSee($index)">
              {{ row.fileName ? row.fileName : '' }}
            </el-link>
            <i
              v-if="row.fileName"
              class="el-icon-circle-close close"
              @click="handleDelete($index)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="proName" label="操作" width="80">
          <template #default="{ $index }">
            <el-upload
              class="upload-demo"
              :action="uploadFileUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :limit="1"
              :auto-upload="true"
              :file-list="file"
              :headers="headers"
              :on-success="(response) => handleFileSuccess(response, $index)"
              :on-change="(file) => handleFileChange(file, $index)"
              :show-file-list="false"
              ref="upload"
            >
              上传
            </el-upload>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <el-dialog
      :visible.sync="dialogVisible"
      title="预览"
      width="800"
      append-to-body
    >
      <img
        :src="dialogImageUrl"
        style="display: block; max-width: 100%; margin: 0 auto"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
// 接口
import { handleDelete } from '@/api/submit'
export default {
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      headers: {
        Authorization: getToken()
      },
      file: [],
      baseUrl: process.env.VUE_APP_BASE_HTTP,
      uploadFileUrl:
        process.env.VUE_APP_BASE_HTTP + '/mailbox-system/oss/file/upload', // 上传的文件服务器地址
      form: {
        Designation: undefined,
        material_reques: undefined,
        files: []
      },
      rules: {},
      tableData: [
        {
          Designation: '法定代表人证明书、有效身份证明',
          material_reques: '法定代表人身份证明',
          fileName: '',
          type: 1
        },
        {
          Designation: '代理人授权委托书、有效身份证明',
          material_reques:
            '委托代理人办理投诉事务的，需提供代理人授权委托书（明确有关委托代理权限和事项）、身份证明',
          fileName: '',
          type: 2
        },
        {
          Designation: '投诉书',
          material_reques:
            '投诉书内容应当符合《工程建设项目招标投标活动投诉处理办法》（国家七部委令第11号）规定投诉人是法人的，投诉书必须由法定代表人或者授权代表签字并盖章；其他组织或者自然人投诉的，投诉书必须由其主要负责人或者投诉人本人签字，并附有效身份证明复印件',
          fileName: '',
          type: 3
        },
        {
          Designation: '提出异议的证明文件',
          material_reques:
            '对招标投标法实施条例规定应先提出异议的事项进行投诉的，应当附提出异议的证明文件',
          fileName: '',
          type: 4
        },
        {
          Designation: '其他',
          material_reques: '无',
          fileName: '',
          type: 5
        }
      ],
      id: undefined,
      url: undefined,
      newUrl: undefined
    }
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      this.dialogImageUrl = file.response.data.accessUrl
      this.dialogVisible = true
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
    //所选文件改变回调
    handleFileChange(file, index) {
      this.tableData[index].fileName = file.name
    },
    // 文件上传成功
    handleFileSuccess(res, index) {
      this.tableData[index].accessUrl = res.data.accessUrl
      this.id = res.data.id
      this.newUrl = res.data.accessUrl
      let obj = {
        fileId: res.data.id,
        businessType: this.tableData[index].type
      }
      let fileIndex = this.form.files.findIndex(
        (i) => i.businessType == this.tableData[index].type
      )
      if (fileIndex >= 0) {
        this.form.files.splice(fileIndex, 1, obj)
      } else {
        this.form.files.push(obj)
      }
    },
    // 删除
    async handleDelete(index) {
      const res = await handleDelete(this.id)
      if (res.success) {
        this.$message({
          message: '删除成功！',
          type: 'success'
        })
        this.file = []
        this.tableData[index].fileName = ''
      }
    },
    // 预览
    handleSee(index) {
      window.open(this.newUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table th.el-table__cell {
  background-color: #f2f2f2;
}
span {
  color: #d9001b;
  font-size: 12px;
}
.db {
  padding-right: 6px;
}
// ::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
//   width: 300px;
// }

// .close {
//   display: none;
//   &:hover {
//     display: block;
//   }
// }

// p{
//   display: inline-block;
//   width: 20px;
//   height: 20px;
//   border-radius: 50%;
//   background-color: #f2f2f2;
//   position: absolute;
//   right: 0;
//   top: 15px;
//   // z-index: -1;
// }
</style>
